import {styled} from "@mui/material";

export const PaymentDetailsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    gap: '1rem',

    '& .MuiGrid-root': {
        display: 'flex',

    }
}));

export const PaymentDetailsBlock = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: '0.5rem 0.5rem'
}));

export const PaymentDetailsRightBlock = styled(PaymentDetailsBlock)(({theme}) => ({
    borderRadius: '0.5rem',
    alignItems: 'end',
    backgroundColor: theme.barekam.background
}));

